<script>
import { mapActions, mapState } from 'vuex';
import skiRental from "./SkiRental.vue";

export default {
  name: 'SkiRentalPickupPlaces',
  props: {
    skiRental: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPickupPlace: null,
      autoSelectedPickupPlace: false,
    };
  },
  created() {
    if (this.skiRental) {
      this.getSkiRentalPickupPlaces();
    } else {
      this.getSkiPassPickupPlaces();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.skiRentalPickupPlaces.find(skiRentalPickupPlace => skiRentalPickupPlace.selected) === undefined && this.autoSelectedPickupPlace) {
      const proceed = window.confirm('Please make sure to save your auto-selected pickup place or choose another one before leaving this page.');
      if (!proceed) {
        next(false);
        return;
      }
    }
    next();
  },
  methods: {
    ...mapActions({
      getSkiRentalPickupPlaces: 'skirental/getPickupPlaces',
      saveSkiRentalPickupPlace: 'skirental/savePickupPlace',
      getSkiPassPickupPlaces: 'skipass/getPickupPlaces',
      saveSkiPassPickupPlace: 'skipass/savePickupPlace',
    }),
    save() {
      const selectedPickupPlaceId = { areaPickupId: null };
      if (this.selectedPickupPlace) {
        selectedPickupPlaceId.areaPickupId = this.selectedPickupPlace.id;
      }
      if (this.skiRental) {
        this.saveSkiRentalPickupPlace(selectedPickupPlaceId);
      } else {
        this.saveSkiPassPickupPlace(selectedPickupPlaceId);
      }
      this.autoSelectedPickupPlace = false
    },
    resetSelectedPickupPlace(pickupPlace) {
      // Vuetify clearable doesnt reset with v-model only clears the input field.
      if (typeof pickupPlace === 'undefined') {
        this.selectedPickupPlace = null;
      }
    },
  },
  watch: {
    skiRentalPickupPlaces(value) {
      let selected = value.find(e => e.selected);
      if (typeof selected === 'undefined') {
        this.autoSelectedPickupPlace = true
        this.selectedPickupPlace = value[0];
      } else {
        this.selectedPickupPlace = selected;
      }
    },
    skiPassPickupPlaces(value) {
      if (value.length) {
        let selected = value.find(e => e.selected);
        if (typeof selected === 'undefined') {
          this.autoSelectedPickupPlace = true
          this.selectedPickupPlace = value[0];
        } else {
          this.selectedPickupPlace = selected;
        }
      }
    },
  },
  computed: {
    ...mapState({
      skiRentalPickupPlaces: state => state.skirental.pickupPlaces.items,
      saveSkiRentalSuccess: state => state.skirental.savePickupPlace.success,
      saveSkiRentalError: state => state.skirental.savePickupPlace.error,
      skiPassPickupPlaces: state => state.skipass.pickupPlaces.items,
      saveSkiPassSuccess: state => state.skirental.savePickupPlace.success,
      saveSkiPassError: state => state.skirental.savePickupPlace.error,
    }),
  },
};
</script>

<template>
  <v-container>
    <v-layout>
      <v-flex class="xs4">
        <v-select
          v-model="selectedPickupPlace"
          :items="skiRental ? skiRentalPickupPlaces : skiPassPickupPlaces"
          item-value="id"
          item-text="title"
          clearable
          return-object
          @change="resetSelectedPickupPlace"
        />
        <v-btn
          color="success"
          class="mt-5"
          block
          @click="save"
        >
          Save
        </v-btn>
        <div class="text-sm-center mt-3">
          <v-chip
            v-if="saveSkiRentalSuccess || saveSkiPassSuccess"
            color="success"
            text-color="white"
          >
            Successfully saved pickup place
          </v-chip>
          <v-chip
            v-if="saveSkiRentalError || saveSkiPassError"
            color="error"
          >
            Failed to save pickup place
          </v-chip>
        </div>
      </v-flex>
      <v-flex
        v-if="selectedPickupPlace"
        class="xs8 pl-5"
      >
        <h2>{{ selectedPickupPlace.title }}</h2>
        <p class="mt-2">
          {{ selectedPickupPlace.description }}
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/rental/SkiRentalPickupPlaces.vue